/* eslint-disable */
import type {DocumentNode} from 'graphql';
import * as ApolloReactHooks from '@apollo/client/react';
import type {OauthProvidersQuery, OauthProvidersQueryVariables} from '../types';

export const OauthProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OauthProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oauthProviders"}}]}}]} as unknown as DocumentNode;
/** hook для запроса "OauthProviders" */
export function useOauthProvidersQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<OauthProvidersQuery, OauthProvidersQueryVariables>,
) {
    return ApolloReactHooks.useQuery<OauthProvidersQuery, OauthProvidersQueryVariables>(
        OauthProvidersDocument,
        baseOptions ?? ({} as ApolloReactHooks.QueryHookOptions<OauthProvidersQuery, OauthProvidersQueryVariables>),
    );
}
